
import { ListViewImplementation } from '@commoncore/implementation/ListViewImplementation';
import { CustomSortService } from '@commoncore/services/custom-sort.service';
import { MultiSelectLibrary } from '@commoncore/utils/MultiSelectUtil';
import { AppEvents, EventsList } from '@commoncore/utils/app-events';
import { IndexedDBModule } from '../database/IndexedDBManager';

export class RecentFilesImplementation {
    public globalService:any;
    public universalService:any;
    public listService:any;
    public http:any;
    public sortByLastAccessedDateArray:any=[];
    public multiSelect:any;
    public customSort:any;
    public customMetadata:any;
    public contextMenuService: any;
    public recentlyUploadedData = {};

    public hideNextBtn:boolean = false;
    public hidePrevBtn:boolean = false;
    public gridGap = 30;
    public totalPages:number = 1;
    public currentPage:number = 1;
    public columnFit:any;
    public ceilColumn:any;
    public floorColumn:any;
    public firstLeft: number = 1;
    public cardWidth: any;
    public isRightNavigationClicked: boolean = false;
    public isLeftNavigationClicked: boolean = false;

    listImpl:any;
  loggerService: any;
  public recentnextLink = "";
  db: IndexedDBModule;
  indexDBData:any;
  static singleInstance:any = null;
  public resizeableObjectList = []; // it is used only for resize window frame - do not overwrite or use.

    constructor() {}

    public static getInstance():RecentFilesImplementation{
      if(this.singleInstance == null){
        this.singleInstance = new RecentFilesImplementation();
        return this.singleInstance;
      }else{
        return this.singleInstance;
      }
    }

    public setHandler(globalService){
    this.universalService=globalService.getUniversalServiceRef();
    this.listService = globalService.getListServiceRef();
    this.http = globalService.getHttpClientRef();
    this.customMetadata = globalService.getCustomMetadataServiceRef();
    this.customSort = new CustomSortService(this.universalService);
    this.contextMenuService = globalService.getContextMenuServiceRef();
    this.multiSelect = MultiSelectLibrary.getInstance(globalService);
    this.listImpl = ListViewImplementation.getInstance(globalService);
    this.loggerService = globalService.getLoggerServiceRef();
    this.db = IndexedDBModule.getInstance(globalService);
    this.globalService = globalService;
    }
     

    async checkDataIndexDB(url) {
      //let cTime = new Date().getTime();
      let storeName = "RecentFilesMetadata"
      //var result = await this.db.getAllData(storeName,"RecentFilesImplementation");
      let result = await this.db.getDataFromCursor(storeName,1,"RecentFilesImplementation");
      if (result) {
        var suc = {
          "objects": result
        };
        return suc;
      }
      return false;
    }
  
    saveToIndexDB (url, suc) {
      // this.dataArray = suc['objects'];
       var storeName = "RecentFilesMetadata";
   
       this.db.bulkAdd(storeName, suc['objects']);
   
      
     }

    async getRecentlyAccessedFiles(url,requestFromAllFiles){
      this.universalService.currentViewDataSize = 0
      if(requestFromAllFiles){
      
        this.indexDBData = await this.checkDataIndexDB(url);
        if(!this.indexDBData || this.universalService.currentTab == 'Home') { // added check of 'allfiles', as indexDBData was holding all recent file 
          //this.universalService.showLoader = true;
          this.recentAPI(url,requestFromAllFiles);

        } else {
          this.sortRecentFilesByDate(this.indexDBData);
        }
      }else{
        this.universalService.showLoader = true;
        this.recentAPI(url,requestFromAllFiles);
      }
    }

    recentAPI(url,requestFromAllFiles){
      let cTime = new Date().getTime();
      this.http.get(url).subscribe(
        suc=>{
          suc["objects"]?.map(obj=>{
            obj["horizontalItem"] = requestFromAllFiles ? true : false;
          });
          if( suc["objects"].length > 0){
            AppEvents.emit(EventsList.RECENTLY_ACCESSED_OBJ_FETCHED);
          }
          this.sortRecentFilesByDate(suc);
          if(requestFromAllFiles)
            this.saveToIndexDB(url,suc)
        },
        err=>{
          this.universalService.showLoader = false;
          this.loggerService.log("error in fetching the recent files",err)
        }
      )
    }

    sortRecentFilesByDate(suc){
      this.resizeableObjectList = suc["objects"];
      this.multiSelect = MultiSelectLibrary.getInstance(this.globalService);
      this.recentnextLink = "";
      if (suc["nextLink"]) {
        this.recentnextLink = suc["nextLink"];
        if (this.recentnextLink.includes("sort=")) {
          if (this.recentnextLink.includes("sort=+")) {
            this.recentnextLink=this.recentnextLink.replace("sort=+", "sort=%2B")
          }else if (this.recentnextLink.includes("sort=-")) {
            this.recentnextLink=this.recentnextLink.replace("sort=-", "sort=%2D")
          }
        }
      } else {
        this.recentnextLink = ""
      }

      if(suc["objects"].length == 0 && this.universalService.currentViewDataSize<1){
        this.sortByLastAccessedDateArray = [];  
        this.universalService.recentFilesPreviewArray=[]
        this.universalService.showLoader = false;
        
        if(this.universalService.fetchAllRecentFiles && suc["objects"].length == 0){
          this.universalService.emptyTab = true;
        }else if(this.universalService.fetchAllRecentFiles && suc["objects"].length > 0){ 
          this.universalService.emptyTab = false;
        }
        if(!this.universalService.fetchAllRecentFiles && this.universalService.currentTab =='allfiles'){
          // $(".recentHorizontalView").width(0)
           $(".recentHorizontalView").height(0)
         }
        return;
      }else{
        // if(!this.universalService.isMobileDevice){
        //   $(".recentHorizontalView").height(230);
        // }else{
        //   $(".recentHorizontalView").height("auto");
        // }
        this.universalService.recentFilesPreviewArray=[]
        this.universalService.emptyTab = false;
        this.universalService.showSortButtons = true;
     // this.universalService.showLoader = true;
      // this.loggerService.log("loader is ",this.universalService.showLoader)
      this.sortByLastAccessedDateArray = [];
      this.universalService.recentMobileSelectedObj = [];
      var allData = this.customMetadata.segregateData(suc,"allfilesRecent");
      this.universalService.currentViewDataSize = allData.length;
      if(this.universalService.recentFilesListView && !this.universalService.isMobileDevice){
        setTimeout(() => {
          this.listImpl.decideListOptions('recents');
          this.listImpl.setRecentFilesListview(allData);
        }, 1);
      }else{
        var sortedArray = this.customSort.sortByDates(allData,[],[],"lastAccessedDate");
        this.sortByLastAccessedDateArray = sortedArray[0];
        this.universalService.recentFilesPreviewArray = sortedArray[1];
        this.universalService.showLoader = false;
        if(!this.universalService.fetchAllRecentFiles && this.universalService.listView){
          this.universalService.recentFilesPreviewArray.map(function(object){
            if(object["imageTranscodeUrl"]!=undefined)
              object["imageTranscodeUrl"] = object["imageTranscodeUrl"].replace('size=a','size=c')
          })
        }
        if(!this.universalService.fetchAllRecentFiles){
          setTimeout(() => {
            this.multiSelect.bindMultiSelectLibrary("#recentFilesMainWrapper", "grid_info", ".recentItem:visible", true,this.universalService.virtualGridEnabled,true);
            this.multiSelect.bindMultiSelectUIevent(".tab-content", ".grid_file_child");
          },1000);
        }
      }
      if(this.universalService.recentFilesListView && this.universalService.fetchAllRecentFiles && this.universalService.isMobileDevice) {
        this.multiSelect.bindMultiSelectLibrary("#recentFilesWrapperId", "list_info", ".listItem:visible", false,this.universalService.virtualGridEnabled,false);
        this.multiSelect.bindMultiSelectUIevent(".main-wrapper", ".list_file_child");
        AppEvents.multiSelectEvent.next({"dataArray":this.sortByLastAccessedDateArray})  
      } else if(!this.universalService.recentFilesListView && this.universalService.fetchAllRecentFiles ) {
        setTimeout(() => {
          this.multiSelect.bindMultiSelectLibrary(".recentFilesWrapper", "grid_info", ".gridItem:visible", true,this.universalService.virtualGridEnabled,false);
          this.multiSelect.bindMultiSelectUIevent(".tab-content", ".grid_file_child");
          AppEvents.virtualDOMObservable.next({"updateVDOM":true})
          AppEvents.multiSelectEvent.next({"dataArray":this.sortByLastAccessedDateArray})
        }, 100);
      } 
      }    
    }

    selectAll(event){
      this.listImpl.selectAll(event)
    }

  fetchNextPageData(url) {
    var self = this;
    return new Promise(function (resolve, reject) {
      self.http.get(url).subscribe(
        nextPageData => {
          self.sortRecentFilesByDate(nextPageData);
          resolve({ "resp": nextPageData })
        },
        err => {
          self.universalService.showErrorMessage(err);
          reject(err)
        }
      )
    })
  }


  recentUploadsAPI(url, code, mimeVal){
    var self = this;
    var data;
    return new Promise(function (resolve, reject) {
      self.http.get(url).subscribe(
        async suc => {
          data = await self.customMetadata.segregateData(suc['objects'], mimeVal);
          self.recentlyUploadedData[code] = data;
          self.universalService.objectsPreviewArray = self.recentlyUploadedData[self.universalService.fileUploadMimeType];
          self.universalService.objectsPreviewArray = self.universalService.objectsPreviewArray ? self.universalService.objectsPreviewArray : [];
        },
        err => {
          self.universalService.showErrorMessage(err);
          reject(err)
        }
      )
    })
  }

  homePageRecentUploadObjectsAPI(url){
    var self = this;
    var data;
    var mimeTypes = [{
      "objectsImgs": {
        "filterCode":"image",
        "filterName":"photos"
      },
      "objectsVideos" : {
        "filterCode":"video",
        "filterName":"videos"
      },
      "objectsAudios" : {
        "filterCode":"audio",
        "filterName":"audio"
      },
      "objectsOthers" : {
        "filterCode":"applicationAndText",
        "filterName":"docs"
      }
    }];

    return new Promise(function (resolve, reject) {
      self.http.get(url).subscribe(
        async suc => {
          for (const key in mimeTypes[0]) {
            if(suc && suc[key] && suc[key].length>0 ) {
              var code = mimeTypes[0][key].filterCode;
              var mimeVal = mimeTypes[0][key].filterName;
              var limit = self.getLimitOfObjectsForRecentUploadSection(code);
              data = await self.customMetadata.segregateData(suc[key], mimeVal);
              self.recentlyUploadedData[code] = data.slice(0, limit);
            }
          }
        },
        err => {
          self.universalService.showErrorMessage(err);
          reject(err)
        }
      )
    })
  }


  async updateRecentUploadDataInView(dataObj, filter, mime) {
    
    var limit = this.getLimitOfObjectsForRecentUploadSection(this.universalService.fileUploadMimeType);
    if(this.recentlyUploadedData[mime] && this.recentlyUploadedData[mime].length >= limit) {
      this.recentlyUploadedData[mime].pop();
      let objectsList = [];    
      objectsList.push(dataObj);
      var data = await this.customMetadata.segregateData(objectsList, filter);
      this.recentlyUploadedData[mime].unshift(data[0]);
    } else {
      if(this.recentlyUploadedData[mime] == undefined) {
        this.recentlyUploadedData[mime] = [];
      }
      let objectsList = [];    
      objectsList.push(dataObj);
      var data = await this.customMetadata.segregateData(objectsList, filter);
      this.recentlyUploadedData[mime].unshift(data[0]);
    }
  }

  getLimitOfObjectsForRecentUploadSection( mime) {
    return (mime == "audio" || mime == "applicationAndText") ? 5 : 4;
  }

}